import React from 'react';
import { useNewUiTheme } from '../newUiTheme';
import { ButtonSize } from '../Button';
import { ImageSourcePropType, TextStyle, ViewStyle } from 'react-native';

export interface SelectableOption<DataType = string | number> {
  label: string,
  value: DataType,
  onSelected: () => void,
  disabled?: boolean,
  labelStyle?: TextStyle
  title?: string,
}

export type SelectableOptionItem<DataType> = SelectableOption<DataType> | null | false;

export type SelectableOptionsGroup<DataType> = {
  title: string,
  options: SelectableOptionItem<DataType>[],
}

export function isSelectableOptionsGroup(object: any): object is SelectableOptionsGroup<any> {
  return typeof object === 'object' && 'title' in object && 'options' in object;
}

export function isListOfSelectableOptionsGroups(object: any[]): boolean {
  return object.every(isSelectableOptionsGroup);
}

interface OptionSelectionButtonProps<DataType = string | number> {
  text: string,
  options: (SelectableOptionItem<DataType>)[] | SelectableOptionsGroup<DataType>[],
  size: ButtonSize,
  testId?: string,
  iconSource?: ImageSourcePropType,
  style?: ViewStyle,
  labelStyle?: TextStyle,

  optionsStyle?: ViewStyle,
  customButton?: React.FC<{onClick: () => void, disabled?: boolean}>,
  mobile_popupTitle?: string,
  isDisabled?: boolean,
  title?: string,
}

export interface OptionSelectionButtonLayoutProps<DataType = string | number> extends OptionSelectionButtonProps<DataType> {
  text: string,
  options: SelectableOption<DataType>[] | SelectableOptionsGroup<DataType>[],
  size: ButtonSize,
  testId?: string,
  iconSource?: ImageSourcePropType,
  style?: ViewStyle,
  labelStyle?: ViewStyle,
  optionsStyle?: ViewStyle,
  mobile_popupTitle?: string,
  customButton?: React.FC<{onClick: () => void, disabled?: boolean}>,
  openOnFirstRender?: boolean,
  isDisabled?: boolean,
  title?: string,
}

export function OptionSelectionButton<DataType = string | number>(
  props: OptionSelectionButtonProps<DataType>,
) {
  const uiTheme = useNewUiTheme();

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const Layout = uiTheme.widgets.OptionSelectionButtonLayout as React.FC<OptionSelectionButtonLayoutProps<DataType>>;

  return (
    <Layout
      {...props}
      options={props.options.filter((option) => !!option) as SelectableOption<DataType>[]}
      customButton={props.customButton}
      isDisabled={props.isDisabled}
      title={props.title}
    />
  );
}
